import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAuth } from '../context/AuthContext';

const Pricing = () => {
  const { isAuthenticated } = useAuth();

  const plans = [
    {
      name: 'Básico',
      price: '$19',
      period: '/mes',
      features: [
        '10,000 Palabras IA',
        '25 Imágenes IA',
        'Soporte Estándar',
        'Acceso a generación de texto',
        'Acceso a generación de imágenes'
      ],
      cta: 'Empezar',
      highlighted: false
    },
    {
      name: 'Profesional',
      price: '$49',
      period: '/mes',
      features: [
        '50,000 Palabras IA',
        '100 Imágenes IA',
        'Acceso a Ciberseguridad',
        'Acceso a Contabilidad',
        'Acceso a Asesoría Legal',
        'Soporte Prioritario',
        'API Access'
      ],
      cta: 'Empezar',
      highlighted: true
    },
    {
      name: 'Empresa',
      price: 'Contacto',
      period: '',
      features: [
        'Palabras Ilimitadas',
        'Imágenes Ilimitadas',
        'Acceso a todos los servicios',
        'Soporte Dedicado 24/7',
        'Personalización completa',
        'SLA Garantizado',
        'Integraciones personalizadas'
      ],
      cta: 'Contactar Ventas',
      highlighted: false
    }
  ];

  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-black text-gray-900 dark:text-white mb-4">
              Elige el Plan Perfecto para Ti
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300">
              Comienza gratis o elige el plan que se adapte a tus necesidades
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {plans.map((plan) => (
              <div
                key={plan.name}
                className={`rounded-xl p-6 flex flex-col gap-4 shadow-sm ${
                  plan.highlighted
                    ? 'bg-primary text-white ring-2 ring-primary/50 transform scale-105'
                    : 'bg-white dark:bg-[#1a2530] border border-gray-200 dark:border-[#283039]'
                }`}
              >
                <h3 className={`text-lg font-bold ${
                  plan.highlighted ? 'text-white' : 'text-gray-900 dark:text-white'
                }`}>
                  {plan.name}
                </h3>
                
                <p className={`text-3xl font-black ${
                  plan.highlighted ? 'text-white' : 'text-gray-900 dark:text-white'
                }`}>
                  {plan.price}
                  {plan.period && (
                    <span className={`text-sm font-medium ${
                      plan.highlighted ? 'text-white/80' : 'text-gray-500 dark:text-gray-400'
                    }`}>
                      {plan.period}
                    </span>
                  )}
                </p>
                
                <ul className="space-y-2 text-sm flex-grow">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2">
                      <span className={`material-symbols-outlined text-sm ${
                        plan.highlighted ? 'text-white' : 'text-green-500'
                      }`}>
                        check_circle
                      </span>
                      <span className={plan.highlighted ? 'text-white' : 'text-gray-600 dark:text-gray-300'}>
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>
                
                <Link
                  to={isAuthenticated ? "/dashboard" : "/register"}
                  className={`w-full mt-4 flex items-center justify-center rounded-lg h-10 px-4 font-bold ${
                    plan.highlighted
                      ? 'bg-white text-primary hover:bg-gray-100'
                      : 'bg-primary/20 text-primary hover:bg-primary/30'
                  } transition-colors`}
                >
                  {plan.cta}
                </Link>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-8">
              Preguntas Frecuentes
            </h2>
            <div className="max-w-3xl mx-auto space-y-4">
              <details className="bg-white dark:bg-[#1a2530] p-4 rounded-lg">
                <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                  ¿Puedo cambiar de plan en cualquier momento?
                </summary>
                <p className="mt-2 text-gray-600 dark:text-gray-300">
                  Sí, puedes actualizar o degradar tu plan en cualquier momento.
                </p>
              </details>
              <details className="bg-white dark:bg-[#1a2530] p-4 rounded-lg">
                <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                  ¿Qué métodos de pago aceptan?
                </summary>
                <p className="mt-2 text-gray-600 dark:text-gray-300">
                  <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded text-sm font-semibold">PRÓXIMAMENTE</span> - Métodos de pago en desarrollo
                </p>
              </details>
              <details className="bg-white dark:bg-[#1a2530] p-4 rounded-lg">
                <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                  ¿Ofrecen reembolsos?
                </summary>
                <p className="mt-2 text-gray-600 dark:text-gray-300">
                  Sí, ofrecemos garantía de devolución de dinero de 30 días.
                </p>
              </details>
            </div>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default Pricing;